var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNavFilemanager = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo__filemanager",
    x: "0px",
    y: "0px",
    viewBox: "0 0 67.7 60",
    style: {
      enableBackground: "new 0 0 67.7 60"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.302;enable-background:new    ;}\n\t#logo__filemanager .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#0066CC;}\n\t#logo__filemanager .st2{fill-rule:evenodd;clip-rule:evenodd;fill:#124B84;}\n\t#logo__filemanager .st3{fill:#376593;}\n\t#logo__filemanager .st4{fill:transparent;}\n\t#logo__filemanager .st5{fill:#FCFDFD;}\n\t#logo__filemanager .st6{fill:#FDFDFD;}\n\t#logo__filemanager .st7{fill:#FCFCFD;}\n\t#logo__filemanager .st8{fill:#446F9A;}\n\t#logo__filemanager .st9{fill:#6387AA;}\n\t#logo__filemanager .st10{fill:#C2D0DE;}\n\t#logo__filemanager .st11{fill:none;}\n\t#logo__filemanager .st12{fill:#FFFFFF;}\n\t#logo__filemanager .st13{font-family:'Poppins';}\n\t#logo__filemanager .st14{font-size:24.72px;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_790_copy_5_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_790_copy_5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.1,12.2H5c-0.4,0-0.7,0.3-0.7,0.7v44.4c0,0.4,0.3,0.7,0.7,0.7h58.1c0.4,0,0.7-0.3,0.7-0.7V13 C63.8,12.6,63.5,12.2,63.1,12.2z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_791_copy_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_791_copy"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.7,13H5.8C5.4,13,5,13.3,5,13.7v13.9c0,0.4,0.3,0.7,0.7,0.7h55.9c0.4,0,0.7-0.3,0.7-0.7V13.7 C62.4,13.3,62.1,13,61.7,13z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "icons8-folder-208_copy_2_xA0_Image_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M61.7,59.8c-0.6,0-1.1,0-1.7,0c-0.1-0.1-0.1-0.2-0.2-0.2c-0.3,0-0.6,0-1,0c-16.6,0-33.2,0-49.8,0 c-0.3,0-0.6,0-1,0c-0.1,0-0.1,0.1-0.2,0.2c-0.5,0-1,0-1.4,0c-0.1-0.5-0.5-0.1-0.6-0.3c-0.2-0.2-0.4-0.3-0.6-0.4 c-1.2-0.6-2.3-1.4-3.1-2.6c-0.4-0.6-0.8-1.3-0.9-2C1.1,53.6,1,52.7,1,51.8c0-3.8,0-7.7,0-11.5c0-3.8,0-7.6,0-11.4 c0-3.8,0-7.7,0-11.5C1,13.6,0.7,9.8,1.2,6c0-0.3,0-0.5,0.1-0.8c0.9-1.7,1.9-3.1,3.8-3.8C5.6,1.2,6,1,6.5,0.7c5.4,0,10.9,0,16.3,0 c1.8,0.4,3.4,1.3,4.6,2.8c0.7,0.9,1.3,2,1.5,3.2c0.1,0.5,0,1.2,0.6,1.6c10.4,0,20.7,0,31,0c1,0,1.9,0.3,2.7,0.7 c1.4,0.6,2.5,1.5,3.2,2.8c0.3,0.6,0.9,1.2,0.8,2.1c-0.2,0.7,0.3,1.4,0.3,2.1c0,3.2,0,6.3,0,9.5c0,3.2,0,6.4,0,9.6 c0,3.2,0,6.3,0,9.5c0,3.2,0.2,6.3-0.2,9.5c0.1,0.7-0.2,1.3-0.5,1.8c-1.1,1.6-2.4,3-4.4,3.5C62,59.4,61.9,59.6,61.7,59.8z  M61.2,13.8c-1.1-0.4-2.1-0.3-3.1-0.3c-16.4,0-32.8,0-49.2,0c-0.2,0-0.5,0-0.7,0C7.1,13.7,6,14.3,6,15.7C6,27.9,6,40,6,52.2 c0,1.4,0.9,2.3,2.3,2.3c17.5,0,35,0,52.4,0c1.3-0.6,1.7-1.5,1.7-2.8c0-11.6,0-23.1,0-34.7c0-0.6,0-1.2,0-1.9 C62,14.7,61.6,14.2,61.2,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.2,13.9c0.1-0.8-0.5-1.4-0.8-2.1c-0.7-1.3-1.9-2.2-3.2-2.8c-0.9-0.4-1.7-0.7-2.7-0.7c-10.3,0-20.7,0-31,0 c-0.6-0.4-0.5-1.1-0.6-1.6c-0.1-1.3-0.7-2.3-1.5-3.2c-1.2-1.5-2.7-2.4-4.6-2.8c-0.1-0.1-0.1-0.2-0.2-0.2 c-0.1-0.1-0.2-0.2-0.3-0.2c15.1,0,30.2,0,45.4,0c0,4.7,0,9.4,0,14.2c-0.1-0.1-0.2-0.2-0.2-0.3C67.4,14,67.3,14,67.2,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M6.5,0.7C6,1,5.6,1.2,5.1,1.4C3.3,2.2,2.2,3.6,1.3,5.2C1.2,5.5,1.2,5.7,1.2,6C0.9,6,1,6.3,1,6.4 c0,0.1-0.2,0.2-0.2,0.3c0-2.2,0-4.3,0-6.5c2.1,0,4.2,0,6.2,0C6.9,0.3,6.8,0.4,6.8,0.5C6.7,0.6,6.6,0.6,6.5,0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M61.7,59.8c0.2-0.2,0.4-0.4,0.6-0.4c2-0.5,3.3-1.9,4.4-3.5c0.3-0.5,0.6-1.1,0.5-1.8c0.2,0,0.3,0,0.5,0 c0,1.9,0,3.8,0,5.8C65.7,59.8,63.7,59.8,61.7,59.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1.2,54.5c0.2,0.7,0.5,1.4,0.9,2C2.9,57.6,4,58.4,5.2,59c0.2,0.1,0.4,0.3,0.6,0.4c0.2,0.2,0.6-0.2,0.6,0.3 c-1.9,0-3.8,0-5.8,0c0-2,0-4,0-6C1,53.8,0.9,54,1,54.2C1,54.3,1.1,54.4,1.2,54.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M7.9,59.8C8,59.7,8,59.5,8.1,59.5c0.3,0,0.6,0,1,0c16.6,0,33.2,0,49.8,0c0.3,0,0.6,0,1,0 c0.1,0,0.1,0.1,0.2,0.2C42.6,59.8,25.3,59.8,7.9,59.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1.2,54.5C1.1,54.4,1,54.3,1,54.2C0.9,54,1,53.8,0.7,53.8c0-15.7,0-31.4,0-47C0.8,6.6,0.9,6.5,1,6.4 C1,6.3,0.9,6,1.2,6C0.7,9.8,1,13.6,1,17.4c0,3.8,0,7.7,0,11.5c0,3.8,0,7.6,0,11.4c0,3.8,0,7.7,0,11.5C1,52.7,1.1,53.6,1.2,54.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M67.7,54c-0.2,0-0.3,0-0.5,0c0.5-3.2,0.2-6.3,0.2-9.5c0-3.2,0-6.3,0-9.5c0-3.2,0-6.4,0-9.6 c0-3.2,0-6.3,0-9.5c0-0.7-0.4-1.3-0.3-2.1c0.1,0.1,0.2,0.1,0.2,0.2c0.1,0.1,0.2,0.2,0.2,0.3C67.7,27.6,67.7,40.8,67.7,54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M6.5,0.7c0.1-0.1,0.2-0.2,0.3-0.2C6.8,0.4,6.9,0.3,7,0.2c5.1,0,10.2,0,15.4,0c0.1,0.1,0.2,0.2,0.3,0.2 c0.1,0.1,0.1,0.2,0.2,0.2C17.4,0.7,11.9,0.7,6.5,0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M61.2,13.8c0.4,0.4,0.8,0.9,1.2,1.4c0,0.7,0,1.3,0,1.9c0,11.6,0,23.1,0,34.7c0,1.3-0.4,2.3-1.7,2.8 c-17.4,0-34.9,0-52.4,0c-1.4,0-2.3-0.9-2.3-2.3C6,40,6,27.9,6,15.7c0-1.4,1.1-2.1,2.2-2.3c0.2,0,0.5,0,0.7,0 c16.4,0,32.8,0,49.2,0C59.1,13.4,60.1,13.3,61.2,13.8z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "A_B"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.3,
    y: 32.6,
    className: "st11",
    width: 38.5,
    height: 22.3
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 14.3136 50.9326)",
    className: "st12 st13 st14"
  }, "A B"))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNavFilemanager, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/nav_filemanager.b28c58f4.svg";
export { ForwardRef as ReactComponent };